export const SITE_NAME = 'Books Experts';
export const SITE_DOMAIN = 'booksexperts.online';
export const SITE_URL = 'https://booksexperts.online';
export const SITE_TAGLINE = 'Expert help for accounting software errors, data repair and licences';
export const COMPANY_NAME = 'Nodex Global LLC';
export const ADDRESS_LINE1 = '32 N Gould St.';
export const ADDRESS_LINE2 = 'Sheridan, WY 82801';
export const ADDRESS = `${ADDRESS_LINE1}, ${ADDRESS_LINE2}`;
export const SUPPORT_EMAIL = 'info@booksexperts.online';
export const POLICY_UPDATED = 'October 6, 2026';
export const META_DESCRIPTION =
  'Books Experts fixes accounting software errors, repairs company data files and supplies genuine desktop licences — with a fixed price agreed before any work starts.';

export const SALES_EMAIL = 'sales@booksexperts.online';
export const RESPONSE_TIME = 'Within one working day';

export const LEAD_API_URL = 'https://lead.dzdstech.com/api/v1/leads';
export const LEAD_API_KEY = 'lms_963ccffba6269a54ecbb403a0a0f71c10fa5336219ec33ed';

export const SUPPORT_PHONE_LABEL = '+1 855-483-6922';
export const SUPPORT_PHONE_TEL = 'tel:+18554836922';
